import { Component } from '@angular/core';
import {LoadingService} from "../services/LoadingService";
import {TOAST_TYPE} from "../constants/Tpiq.constants";
import {ToastService} from "../services/Toast.service";
import {TaxPlanningService} from "../tpiq-services/tax-planning.service";
import {SwitchBoard} from "../services/SwitchBoard";
import {Router} from "@angular/router";
import {Session} from "../services/Session";
import {LoginService} from "../services/Login.service";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent {
  password: string;
  notValid = false;
  confirmPassword: string;
  taxPlanningTerms: any;

  constructor(private _router: Router, private _toastService: ToastService,
              private loadingService: LoadingService, private loginService: LoginService,
              private switchBoard: SwitchBoard,
              private taxPlanningService: TaxPlanningService) {
  }

  ngOnDestroy(){
  }

  handleError(err){

  }
  submit($event){
    $event && $event.preventDefault();
    if (this.checkPasswordsMatch()){
      const data = {
        id: Session.getUser('delegatedFrom').id,
        password: this.password
      };
      this.loginService.updatePassword(data).subscribe(res => {
        if (res){
          const user: any = Session.getUser();
          if (user.isCustomer){
            this.handleCustomerNavigation();
          }else {
            this.loadingService.triggerLoadingEvent(true);
            this.taxPlanningService.getTermsAndConditions(Session.getOrg(), user.id).subscribe(response => {
              this.loadingService.triggerLoadingEvent(false);
              this.taxPlanningTerms = response || {};
              Session.setTaxPlanOrgTerms(response);
              const accessInfo: any = Session.getUserAccessInfo();
              if (!this.taxPlanningTerms.termsAccepted) {
                this._router.navigate(['tax-planning/terms']);
                return;
              } else if (accessInfo && accessInfo.subscriptionStatus == 'Suspended'){
                this._router.navigate(['tax-planning/manage-billing']);
                return;
              } else {
                let status: any = Session.get('user').onboardingStatus;
                if ((status && status === 'Done')  || !status) {
                  this.switchBoard.onLogin.next(Session.get('user'));
                  const homeobj = {
                    type: 'taxPlanningHome',
                    route: 'taxPlanning',
                    clearAllStates: true
                  };
                  setTimeout(() => {
                    this.switchBoard.onWallTpiqSwitch.next(homeobj);
                  });
                } else if (status && status !== 'Done') {
                  this._router.navigate(['tpiq/onboard']);
                }
              }
            });
          }
        }
      }, error => {
        this._toastService.pop(TOAST_TYPE.error, 'Failed To Update Password');
      });
    }
  }

  handleCustomerNavigation() {
    const link = ['tax-planning/customer/dashboard'];
    this._router.navigate(link);
    this.switchBoard.onLogin.next(Session.get('user'));
  }

  checkPasswordsMatch() {
    if (this.password && this.confirmPassword && this.password === this.confirmPassword) {
      this.notValid = false;
      return true;
    }else {
      this.notValid = true;
      return false;
    }
  }

}
